// @flow
import * as React from 'react';

// eslint-disable-next-line
export default class LightViewFooter extends React.Component<any, any> {
  render() {
    return (
      <a
        href="https://www.ava.me/pro/events/"
        style={{
          textDecoration: 'none',
          color: 'inherit',
        }}
      >
        <div
          style={{
            backgroundColor: '#15191C',
            display: 'flex',
            position: 'fixed',
            bottom: 0,
            marginTop: 'auto',
            marginBottom: 'auto',
            width: '100%',
            height: '3rem',
            color: 'rgb(220, 220, 220)',
          }}
        >
          <div
            style={{
              marginTop: 'auto',
              marginBottom: 'auto',
              marginRight: 'auto',
              fontFamily: '"Source Sans Pro", sans-serif',
              fontSize: '16pt',
              margin: 'auto',
            }}
          >
            Live Transcription by Ava
          </div>
        </div>
      </a>
    );
  }
}
